import React from 'react';
import './OurStory.css';
import storyWave from '../../assets/waves/Shape 2.svg';
import img1 from '../../assets/about/garden-planting-new-castle-colorado.png';
import img2 from '../../assets/about/outdoor-patio-design-carbondale-co.png';
import img3 from '../../assets/about/flagstone-pathway-basalt-colorado.png';

const OurStory = () => (
  <section className="story">
    <div className="story__inner">
      <div className="story__images">
        <div className="story__img story__img--tall"><img src={img1} alt="Garden planting New Castle Colorado" /></div>
        <div className="story__img story__img--square-top"><img src={img2} alt="Outdoor patio design Carbondale CO" /></div>
        <div className="story__img story__img--square-bottom"><img src={img3} alt="Flagstone pathway Basalt Colorado" /></div>
      </div>
      <div className="story__content">
        <span className="story__tag">Our Story</span>
        <h2 className="story__heading">Built on a <span className="story__heading-accent">fresh start</span> Rooted in the Valley</h2>
        <div className="story__body">
          <p>The name was never just branding. When Jennifer founded this company, a fresh start meant something personal. Overcoming real obstacles to build something she truly believed in. That intention became the soul of every project that followed.</p>
          <p>What she built over the next 20 years is a team that treats your outdoor space the way she treats her own work: with genuine care, real listening, and a commitment to getting it right. We want to know how you actually live, what you want to feel when you step outside, and what has been standing in the way of that. The design comes after all of that — never before.</p>
          <p>We are a family business based in New Castle, Colorado. That closeness shows up in the relationships we build, the care we put into every project, and the spaces we leave behind. We serve homeowners across the Roaring Fork Valley, from Aspen and Basalt to Carbondale, Glenwood Springs, and our home in New Castle.</p>
        </div>
      </div>
    </div>
    <img src={storyWave} alt="" className="story__wave" />
  </section>
);

export default OurStory;
